import { API } from '../../config/api';
import { GET, PUT } from '../../utils/apicalls';
import { Button, Card, DatePicker, Form, Input, notification, Select } from 'antd';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Initialize dayjs plugins for timezone handling
dayjs.extend(utc);
dayjs.extend(timezone);

function UpdateOffer() {
    const [form] = Form.useForm();
    const [productData, setProductData] = useState<any>([]);
    const [data, setData] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);
    const [fileUrl, setFileUrl] = useState<string | null>(null);
    const navigate = useNavigate();
    const { id } = useParams();

    const updateHandler = async (values: any) => {
        try {
            let obj = {
                Offer_start_time: values.Offer_start_time,
                Offer_End_time: values.Offer_End_time,
                Offer_price: Number(values.Offer_price),
                Product_id: values.Product_id,

            };

            setIsLoading(true);
            let api = API.UPDATE_OFFER_PRODUCT + id;
            const putRequest: any = await PUT(api, obj);
            if (putRequest.status) {
                notification.success({ message: "Offer updated successfully!" });
                form.resetFields();
                navigate(-1);
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const fetchOneOffer = async () => {
        try {
            setIsLoading(true);
            let api = API.FIND_ONE_OFFER_PRODUCT + id;
            const response: any = await GET(api, {});
            setData(response?.data);

            // Transform the date strings to dayjs objects for DatePicker
            const formValues = {
                ...response?.data,
                Offer_start_time: response?.data?.Offer_start_time ? dayjs(response.data.Offer_start_time) : null,
                Offer_End_time: response?.data?.Offer_End_time ? dayjs(response.data.Offer_End_time) : null,
                Product_id: response?.data?.Product_id
            };

            form.setFieldsValue(formValues);

            if (response?.data?.offerImage) {
                setFileUrl(response.data.offerImage);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchProducts = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.PRODUCT_GET_LISTING, {});
            setProductData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchOneOffer();
        fetchProducts();
    }, []);

    return (
        <div>
            <Card>
                <h1>Update Offer</h1>
                <Form form={form} onFinish={updateHandler} layout="vertical">
                    <Row>
                        <Col md={6}>
                            <Form.Item name="Offer_start_time" label="Offer Start Time" rules={[{ required: true }]}>
                                <DatePicker
                                    showTime={{ format: "HH:mm:ss" }}
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={6}>
                            <Form.Item name="Offer_End_time" label="Offer End Time" rules={[{ required: true }]}>
                                <DatePicker
                                    showTime={{ format: "HH:mm:ss" }}
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Item name="Offer_price" label="Offer Price" rules={[{ required: true }]}>
                                <Input type="number" />
                            </Form.Item>
                        </Col>
                        <Col md={6}>
                            <Form.Item name="Product_id" label="Product" rules={[{ required: true }]}>
                                <Select placeholder="Select a Product">
                                    {productData?.map((product: any) => (
                                        <Select.Option key={product.id} value={product.id}>
                                            {product.productTitle}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Button type="primary" htmlType="submit" loading={isLoading} block>
                        Update Offer
                    </Button>
                </Form>
            </Card>
        </div>
    );
}

export default UpdateOffer;
